import React, { ReactNode } from 'react';
import { OnboardingPageBodyWrapper } from './onboarding-page-body';
import { OnboardingPageHeader } from './onboarding-page-header';
import "./onboarding-page.scss"

type Link = {
  url: string;
  text: string;
}


export type OnboardingPageProps = {
  links?: Link[]
  user?: string;
  hideProfile?: boolean;
  children?: ReactNode;
  image?: string;
  title?: string;
  hideSubnav?: boolean;
  buttonText?: string;
  heading?: string;
  quote?: string;
  authorName?: string;
  authorRole?: string;
  onBackClick?: () => void;
  onButtonClick?: () => void;
};

export function OnboardingPage(props: OnboardingPageProps) {
  const { links, user, hideProfile, children, image, heading, title, buttonText, hideSubnav, onButtonClick, onBackClick, quote, authorName, authorRole } = props;
  return (
    <div className='onboarding-page'>
      <OnboardingPageHeader links={links} user={user} hideProfile={hideProfile} />
      <OnboardingPageBodyWrapper heading={heading} buttonText={buttonText} onButtonClick={onButtonClick} image={image} title={title} hideSubnav={hideSubnav} quote={quote} authorName={authorName} authorRole={authorRole} onBackClick={onBackClick}>
        {children}
      </OnboardingPageBodyWrapper>
    </div>
  );
}
